<div class="visit-planner-container">

  <div class="header">
    <div>{{title}} </div>
    <fi-button
      variant="tertiary"
      tone="neutral"
      size="lg"
      [iconOnly]="true"
      (click)="closeDialog()"
    >
      <mat-icon fiButtonIcon>close</mat-icon>
      <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
    </fi-button>
  </div>

  <div class="main-container">
    <div class="horizontal-container">
      <fi-request-contacts [contactToDisplay]="contactToDisplay" [companyContacts]="companyContacts"></fi-request-contacts>
      <div class="form has-date-dropdown">
        <div class="form-title has-checkbox" [class.external-only]="isExternal">
          <span>
            <span fiTranslation="REQUEST_DETAIL_APPOINTMENT_HEADLINE_APPOINTMENT_DETAILS"></span>
            @if (isExternal) {
              <span class="badge" fiTranslation="REQUEST_CREATE_APPOINTMENT_BADGE_EXTERNAL_ENQUIRY"></span>
            }
          </span>
          <fi-checkbox class="checkbox" [(ngModel)]="sameAsContactAddress" (checkedChange)="onSameAsContactAddressChange()">
            <span class="text" fiTranslation="REQUEST_CREATE_SAME_CONSTUCTION_ADDRESS"></span>
          </fi-checkbox>
        </div>

        <div class="row">
          <fi-input
            [hasError]="!sameAsContactAddress && addressError"
            [readOnly]="sameAsContactAddress"
            maxLength="128"
            labelKey="REQUEST_DETAIL_HEADLINE_ADDRESS"
            (onChange)="address = $event; addressError = false;"
            [selectedOptionsOrValues]="address">
          </fi-input>

          <div class="row">
            <fi-input
              [hasError]="!sameAsContactAddress && postCodeError"
              [readOnly]="sameAsContactAddress"
              maxLength="128"
              labelKey="REQUEST_CREATE_CONTACT_HEADLINE_ZIPCODE"
              (onChange)="postCode = $event; postCodeError = false;"
              [selectedOptionsOrValues]="postCode">
            </fi-input>

            <fi-input
              [hasError]="!sameAsContactAddress && localityError"
              [readOnly]="sameAsContactAddress"
              maxLength="128"
              labelKey="REQUEST_CREATE_CONTACT_HEADLINE_CITY"
              (onChange)="locality = $event; localityError = false;"
              [selectedOptionsOrValues]="locality">
            </fi-input>
          </div>

        </div>

        <div class="row">
          <fi-input
            type="SELECT"
            [readOnly]="sameAsContactAddress"
            [enableSearch]="true"
            labelKey="REQUEST_CREATE_CONTACT_HEADLINE_COUNTRY"
            [options]="resourceCountries"
            [selectedOptionsOrValues]="countryCode"
            namePropertyPath="Name"
            valuePropertyPath="IsoCode"
            (onChange)="setCountyCode($event)"
            >
          </fi-input>

          @if (provinceCountryCodes.includes(countryCode)) {
            <fi-input
              [readOnly]="sameAsContactAddress"
              [selectedOptionsOrValues]="provinceCode"
              type="SELECT"
              [enableSearch]="true"
              labelKey="REQUEST_CREATE_CONTACT_HEADLINE_PROVINCE"
              [options]="resourceProvinces"
              namePropertyPath="Text"
              valuePropertyPath="Code"
              (onChange)="setProvinceCode($event)"
              >
            </fi-input>
          }

        </div>

        <div class="row">
          <fi-input
            labelKey="ACTION_GENERAL_HEADLINE_DATE"
            type="DAY"
            [selectedOptionsOrValues]="selectedDate"
            (onDateTimeChange)="onDateSelect($event)"
            >
          </fi-input>

          <fi-input
            labelKey="REQUEST_DETAIL_APPOINTMENT_TIME"
            type="TIME"
            [selectedOptionsOrValues]="selectedDate"
            (onDateTimeChange)="onDateSelect($event, true)"
            >
          </fi-input>
        </div>

        @if (appointmentExists) {
          <div class="error-message" fiTranslation="ACTION_APPOINTMENT_OVERLAP"></div>
        }

        <div>
          <div class="field-title" fiTranslation="ACTION_GENERAL_HEADLINE_REQUEST_NOTE2"></div>
          <fi-editor
            [noUploads]="true"
            [placeholderTranslation]="'REQUEST_DETAIL_NOTE_PLACEHOLDER'"
            (isLongDescription)="inValidNote = $event"
            (textChanged)="note = $event">
          </fi-editor>
        </div>
      </div>
    </div>

  </div>

  <div class="footer">
    <button (click)="submit()" [disabled]="!formIsValid">
      <img [src]="iconUrl" alt="Action icon">
      <span> {{title}} </span>
      @if (isExternal) {
        <span class="external" fiTranslation="External"></span>
      }
    </button>
  </div>
</div>
